import { AlertTriangle } from "lucide-react";

export const LowCreditsAlert = ({ masters, threshold }) => {
  const low = (masters || []).filter((m) => m.credits != null && m.credits < threshold);
  if (!low.length) return null;
  return (
    <div data-testid="low-credits-alert" className="flex flex-wrap items-center gap-3 rounded-xl border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-200 fade-up">
      <AlertTriangle className="h-4 w-4 text-red-400" />
      <span className="font-semibold">Créditos baixos:</span>
      {low.map((m) => (
        <span key={m.account} data-testid={`low-credits-${m.account}`} className="rounded-lg bg-red-500/15 px-2 py-0.5 font-mono">
          {m.account}: {m.credits.toLocaleString("pt-BR")}
        </span>
      ))}
      <span className="text-xs text-red-300/70">abaixo de {threshold.toLocaleString("pt-BR")} — recarregue no SYSLOG</span>
    </div>
  );
};
